import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { ThemeContextProvider, ThemeContext } from './context/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeContextProvider>
      <ThemeConsumer />
    </ThemeContextProvider>
  );
}

function ThemeConsumer() {
  const { theme } = React.useContext(ThemeContext);

  return (
    <div className={`min-h-screen transition-colors duration-300 ${theme === 'dark' ? 'dark bg-background-dark' : 'bg-background-light'}`}>
      <Navbar />
      <div>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Projects />
              <Contact />
            </>
          } />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;